module.exports = __webpack_public_path__ + "img/team-listens.c83f0a61.webp";